import React from "react";

import { getRoute, ROUTES } from "../../../utils/ROUTES";
import { ReactComponent as ShareAltIcon } from "../../../images/share-alt.svg";
import CampaignPlaceholder from "../../../images/project-placeholder.svg";
import CustomImage from "../CustomImage/CustomImage";
import { getImageSource } from "../../../utils/methods";
import TooltipPortal from "../TooltipPortal/TooltipPortal";
import useGetProjectAutocomplete from "./useGetProjectAutocomplete";

import "./ProjectSelector.scss";

interface ProjectSelectorProps {
  value: string | null;
  wsWorkspaceUuid: string;
}

export default function ProjectSelector({
  value,
  wsWorkspaceUuid,
}: ProjectSelectorProps) {
  const selectedWsProject = useGetProjectAutocomplete(value);

  if (!selectedWsProject) return null;

  return (
    <div className="project-selector-field">
      <div className="project-selector-field__cover">
        <CustomImage
          fallbackImageSrc={CampaignPlaceholder}
          src={getImageSource(selectedWsProject?.cover, "tiny")}
        />
      </div>
      <TooltipPortal
        content={selectedWsProject?.projectName}
        className="project-selector-field__name"
      >
        {selectedWsProject?.projectName}
      </TooltipPortal>

      <a
        href={getRoute(ROUTES.PROJECT, {
          wsProjectUuid: selectedWsProject?.projectId,
          wsWorkspaceUuid,
        })}
        target="_blank"
        rel="noreferrer"
        className="project-selector-field__link"
      >
        <ShareAltIcon className="share-icon" />
      </a>
    </div>
  );
}
